<template>
    <tr class="session__register_table_item">
        <td class="session__register_table_item_checkbox">
            <list-table-check
                :name="`register-${index}`"
                :emit-list-name="'register-item-list-action'"
                :index="item.learnerId"
            />
        </td>
        <td class="session__register_table_item_name">
            {{ item.firstName }} {{ item.lastName }}
            <template v-if="isPrint">
                <br>{{ item.email }}
            </template>
        </td>
        <template v-if="!isPrint">
            <td class="session__register_table_item_email"><a :href="`mailto:${item.email}`">{{ item.email }}</a></td>
        </template>
        <td :class="['session__register_table_item_attendance', { 'session__register_table_item_attendance--wide' : absenceReason }]">
            <template v-if="isPrint">
                <template v-if="attendance === true">{{ $t('ebs.sessions.register.labels.present') }}</template>
                <template v-else><s>{{ $t('ebs.sessions.register.labels.present') }}</s></template>
                <span> / </span>
                <template v-if="attendance === false">
                    {{ $t('ebs.sessions.register.labels.absent') }}
                    <template v-if="sessionAbsenceReasonRequired">
                        <p>({{absenceReason}} - {{absenceReasonValid ? this.$t('ebs.sessions.register.title.valid') : this.$t('ebs.sessions.register.title.invalid')}})</p>
                    </template>
                </template>
                <template v-else><s>{{ $t('ebs.sessions.register.labels.absent') }}</s></template>
            </template>
            <template v-else>
                <div class="columns">
                    <div class="column custom--left is-narrow">
                        <form-radio-horizontal
                            :label="''"
                            :name="`register-attendance-${index}`"
                            :items="[
                                {
                                    name: this.$t('ebs.sessions.register.name.present'),
                                    value: true
                                },
                                {
                                    name: this.$t('ebs.sessions.register.name.absent'),
                                    value: false
                                }
                            ]"
                            :size="'small'"
                            :disabled="disabled || isCommited"
                            v-model="attendance"
                        />
                    </div>
                    <template v-if="attendance === false && sessionAbsenceReasonRequired">
                        <div class="column">
                            <form-select
                                :label="''"
                                :name="`register-attendance-absence-reason-${index}`"
                                :value="absenceReason"
                                :disabled="disabled || isCommited"
                                :items="sessionAbsenceReasons"
                                :v-validate="'required'"
                                :searchable="false"
                                :is-type="'select'"
                                :data-vv-as="'reason'"
                                :placeholder="$t('ebs.sessions.register.name.chooseReason')"
                                @input="updateAbsenceReason"
                            />
                        </div>
                        <template v-if="absenceReason">
                            <div class="column is-narrow">
                                <form-radio-horizontal
                                    :label="''"
                                    :name="`register-attendance-absence-reason-valid-${index}`"
                                    :v-validate="'required'"
                                    :data-vv-as="'valid'"
                                    :disabled="disabled || isCommited"
                                    :items="[
                                        {
                                            name: this.$t('ebs.sessions.register.name.valid'),
                                            value: true
                                        },
                                        {
                                            name: this.$t('ebs.sessions.register.name.invalid'),
                                            value: false
                                        }
                                    ]"
                                    :size="'small'"
                                    v-model="absenceReasonValid"
                                />
                            </div>
                        </template>
                    </template>
                </div>
            </template>
        </td>
        <td class="session__register_table_item_notes">
            <template v-if="isPrint">
                {{ notes }}
            </template>
            <template v-else>
                <form-textarea
                    :label="''"
                    :name="`register-notes-${index}`"
                    :data-vv-as="'notes'"
                    :v-validate="'max:80'"
                    :disabled="disabled || isCommited || attendance === null"
                    v-model="notes"
                    :class="notes ? (notes.length > 23 ? 'form__textarea--custom-class' : '') : ''"
                />
            </template>
        </td>
    </tr>
</template>

<script>
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import FormTextarea from '@/components/default/forms/FormTextarea'
import ListTableCheck from '@/components/default/shared/ListTableCheck'
import FormSelect from '@/components/default/forms/FormSelect'

export default {
  components: {
    FormSelect,
    ListTableCheck,
    FormTextarea,
    FormRadioHorizontal
  },
  name: 'session-register-table-item',
  props: {
    index: {
      type: [String, Number],
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sessionAbsenceReasonRequired: function () {
      return this.$store.getters.getSessionCompletionAbsenceReasonRequired
    },
    sessionAbsenceReasons: function () {
      const items = this.$store.getters.getSessionCompletionAbsenceReason
      return this.fromStringToArraySelect(items)
    },
    //
    attendance: {
      get () {
        return this.item.attendance
      },
      set (value) {
        this.$store.dispatch('setRegisterAttendance', { index: this.item.learnerId, value: value })
      }
    },
    absenceReason: {
      get () {
        return this.item.absenceReason
      },
      set (value) {
        this.$store.dispatch('setRegisterAbsenceReason', { index: this.item.learnerId, value: value })
      }
    },
    absenceReasonValid: {
      get () {
        return this.item.absenceReasonValid
      },
      set (value) {
        this.$store.dispatch('setRegisterAbsenceReasonValid', { index: this.item.learnerId, value: value })
      }
    },
    notes: {
      get () {
        return this.item.notes
      },
      set (value) {
        this.$store.dispatch('setRegisterNotes', { index: this.item.learnerId, value: value })
      }
    },
    isCommited () {
      return this.item.isCommited === 'true' || this.item.isCommited === true
    },
    isPrint: function () {
      return this.$route.name === 'ebs-session-register-print'
    }
  },
  methods: {
    updateAbsenceReason: function (value) {
      this.$store.dispatch('setRegisterAbsenceReason', { index: this.item.learnerId, value: value })
    },
    //
    previewBookingForm: function () {
      this.$refs.bookingform.openNotify()
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionregistertableitem";
</style>
